export const alphaVert = () => `
  attribute vec4 color;
  varying vec4 vColor;

  void main() {
    vec4 mvPosition = modelViewMatrix * vec4(position, 1.0);
    vColor = color;
    gl_Position = projectionMatrix * mvPosition;
  }
`

export const alphaFrag = () => `
  varying vec4 vColor;

  void main() {
    gl_FragColor = vec4(vColor.rgba);
  }
`
